import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

// URL del bot Telegram - normalmente verrebbe importato da un file di configurazione
const TELEGRAM_BOT_URL = 'https://t.me/escortfun_bot';

const TelegramButton: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

  // Non mostrare il bottone nelle pagine di dettaglio dell'escort
  if (location.pathname.startsWith('/escort/')) {
    return null;
  }

  const handleClick = () => window.open(TELEGRAM_BOT_URL, '_blank');

  return (
    <button
      onClick={handleClick}
      style={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        zIndex: 40,
        background: '#1E88E5', // Colore azzurro
        color: '#fff',
        border: 'none',
        borderRadius: 8,
        padding: '8px 12px',
        fontSize: 14,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
      }}
      aria-label={t('common.prova_il_nostro_bot_telegram')}
    >
      {/* Emoji di Telegram */}
      <span style={{ fontSize: 18 }}>📱</span>
      {t('common.prova_il_nostro_bot_telegram')}
    </button>
  );
};

export default TelegramButton;
